<template>
  <modal :fullscreen="true" :show="show" @close="close">
    <v-flex slot="title">Dodaj Partnera</v-flex>

    <div>
      <v-layout column>
        <v-flex xs12>
          <w-schema :model="$schema.partner.name">
            <v-text-field name="name" label="Nazwa Partnera *"></v-text-field>
          </w-schema>
        </v-flex>

        <v-flex xs12>
          <v-layout row wrap>
            <v-flex pr-2 xs6>
              <w-schema :model="$schema.partner.email">
                <v-text-field name="email" label="Adres e-mail*"></v-text-field>
              </w-schema>
            </v-flex>

            <v-flex pr-2 xs6>
              <w-schema :model="$schema.partner.website">
                <v-text-field name="website" label="Strona internetowa"></v-text-field>
              </w-schema>
            </v-flex>
          </v-layout>
        </v-flex>

        <teryt-form v-if="show" :schema="$schema.partner" :row="true"></teryt-form>

        <v-flex xs12>
          <v-layout row wrap>
            <v-flex pr-2 xs6>
              <w-schema :model="$schema.partner.homeNumber">
                <v-text-field name="homeNumber" label="Numer budynku"></v-text-field>
              </w-schema>
            </v-flex>

            <v-flex pl-2 xs6>
              <w-schema :model="$schema.partner.localNumber">
                <v-text-field name="localNumber" label="Numer lokalu"></v-text-field>
              </w-schema>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12>
          <w-schema :model="$schema.partner.postalCode">
            <v-text-field name="postalCode" label="Kod pocztowy"></v-text-field>
          </w-schema>
        </v-flex>

        <v-flex>
          <h3 class="subheading">Reprezentant Partnera</h3>

          <v-flex xs12>
            <w-schema :model="$schema.profile.email">
              <v-text-field name="email" label="Login (adres e-mail)*"></v-text-field>
            </w-schema>
          </v-flex>

          <v-layout row wrap>
            <v-flex pr-2 xs6>
              <w-schema :model="$schema.profile.firstName">
                <v-text-field name="firstName" label="Imię*"></v-text-field>
              </w-schema>
            </v-flex>

            <v-flex pl-2 xs6>
              <w-schema :model="$schema.profile.lastName">
                <v-text-field name="lastName" label="Nazwisko*"></v-text-field>
              </w-schema>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex class="mb-4" xs12>
          <html-editor :schema="$schema.partner.description"></html-editor>
        </v-flex>

        <v-flex xs12>
          <w-schema :model="$schema.partner.descriptionShort">
            <v-textarea label="Opis skrócony"></v-textarea>
          </w-schema>
        </v-flex>

        <v-flex v-if="show" class="mb-4">
          <v-layout row wrap>
            <v-flex xs12 md6>
              <single-image :schema="$schema.partner.mainImage"></single-image>
            </v-flex>
            <v-flex xs12 md6>
              <images-list :schema="$schema.partner.images"></images-list>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>

    <v-layout slot="actions">
      <v-spacer></v-spacer>

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { mapState } from 'vuex';
import { schemaMixin, WSchema } from '@witkac/vuetify-components';
import { ProfileType } from '@witkac/kartamiejska-shared';

import ImagesList from '@/components/forms/ImagesList';
import HtmlEditor from '@/components/forms/HtmlEditor';
import Modal from '@/components/material/Modal';
import SingleImage from '@/components/forms/SingleImage';
import TerytForm from '@/components/forms/TERYTForm';
import schema from '@/schemas/partner_registration.schema';
import { notificationsMixin } from '@/mixins/notifications';

const emptyData = {
  login: '',
  profile: {
    type: ProfileType.PARTNER,
    email: '',
    firstName: '',
    lastName: ''
  },
  partner: {
    name: '',
    email: '',
    website: '',
    description: '',
    woj: '',
    pow: '',
    gmi: '',
    terc: '',
    city: '',
    simc: '',
    street: '',
    ulic: '',
    mainImage: null,
    images: '',
    descriptionShort: ''
  }
};

// @vuese
// Modal dodawania Partnera
// @group Partners
export default {
  components: { ImagesList, HtmlEditor, Modal, SingleImage, WSchema, TerytForm },
  mixins: [schemaMixin, notificationsMixin],
  schema,
  props: {
    // Boolean kontrolujący widoczność modala
    show: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      model: {
        login: emptyData.login,
        profile: { ...emptyData.profile },
        partner: { ...emptyData.partner }
      },
      profile: { ...emptyData.profile },
      partner: { ...emptyData.partner }
    };
  },
  methods: {
    // @vuese
    // Potwierdzenie zamknięcia formularza w przypadku zmian
    close() {
      if (this.$schema.$dirtyList().length !== 0) {
        this.$store.dispatch('showConfirmDialog');
      } else {
        this.closeModal();
      }
    },
    // @vuese
    // Funkcja emituje event `close` do zamknięcia modalu
    closeModal() {
      // Zamyka modal
      this.$emit('close');
    },
    // @vuese
    // Metoda czyści pola formularza
    clearForm() {
      this.$schema.$setData({
        login: emptyData.login,
        profile: { ...emptyData.profile },
        partner: { ...emptyData.partner }
      });
    },
    // @vuese
    // Metoda zapisuje Partnera
    save() {
      if (!this.$schema.$validateAll().length) {
        this.$emit('save', this.model);
        this.closeModal();
      } else {
        this.notifyError('Błędnie wypełniony formularz');
      }
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.clearForm();
      }
    }
  }
};
</script>
